import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Blackbar from './components/header/blackbar';
import Topbannerad from './components/header/topbanner';
import Home from './pages/home';
import Tirupati from './pages/ap/tirupati';
import Annavaram from './pages/ap/annavaram';
import Srisailam from './pages/ap/srisailam';
import Simhachalam from './pages/ap/simhachalam';

import Shirdi from './pages/mh/shirdi';
import Nashik from './pages/mh/nashik';
import Pandarpur from './pages/mh/pandarpur';
import Kolhapur from './pages/mh/kolhapur';

import Dharmastala from './pages/kt/dharmastala';
import Kollur from './pages/kt/kollur';
import Kukke from './pages/kt/kukke';
import Udupi from './pages/kt/udupi';

import Arunachalam from './pages/tn/arunachalam';
import Madurai from './pages/tn/madurai';
import Palani from './pages/tn/palani';
import Srirangam from './pages/tn/srirangam';

import Stotras from './pages/more/stotras';

import Navbar from './components/header/navbar'; // if you have a navbar
import Footer from './components/footer/footer';

function App() {
  return (
<>
<Blackbar />
<Topbannerad />
    <Router> 
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/ap/tirupati" element={<Tirupati />} />
        <Route path="/ap/annavaram" element={<Annavaram />} />
        <Route path="/ap/srisailam" element={<Srisailam />} />
        <Route path="/ap/simhachalam" element={<Simhachalam />} />

         <Route path="/mh/shirdi" element={<Shirdi />} />
         <Route path="/mh/pandarpur" element={<Pandarpur />} />
         <Route path="/mh/nashik" element={<Nashik />} />
         <Route path="/mh/kolhapur" element={<Kolhapur />} />

         <Route path="/kt/dharmastala" element={<Dharmastala />} />
         <Route path="/kt/kollur" element={<Kollur />} />
         <Route path="/kt/kukke" element={<Kukke />} />
         <Route path="/kt/udupi" element={<Udupi />} />

         <Route path="/tn/arunachalam" element={<Arunachalam />} />
         <Route path="/tn/madurai" element={<Madurai />} />
         <Route path="/tn/palani" element={<Palani />} />
         <Route path="/tn/srirangam" element={<Srirangam />} />

         <Route path="/more/stotras" element={<Stotras />} />

        {/* Other routes */}
      </Routes>
      <Footer />
    </Router>

    </>
  );
}

export default App;
